import React, { createContext, useContext } from 'react';
import { useNavigate } from "react-router-dom";
import { OldOnboarding } from '../../constants/onboardingVersions';
import { DcgAutomation } from '../../constants/onboardingVersions';

// Create APIContext
const APIContext = createContext();

// Custom Hook to use APIContext
export const useAPIContext = () => useContext(APIContext);

// Create a provider for APIContext
export const APIProvider = ({ children, currentPage, isDcgAutomation }) => {
    const navigate = useNavigate();

    const goToPrevPage = () => {
        if (currentPage.prevPage) {
            navigate(`/${DcgAutomation}/${currentPage.prevPage}`);
        } else {
            navigate('/');
        }
    };

    const navigateToPage = (page) => {
        if (page) {
            let prefix = '';
            if (page !== 'requestPortalJoinCode') {
                prefix = isDcgAutomation ? `/${DcgAutomation}` : `/${OldOnboarding}`;
            }
            navigate(`${prefix}/${page}`);
        }
    }
    const isFinalConfirmationPage = currentPage.finalConfirmation ? true : false;
    const postPersonaLandingPage = isDcgAutomation ? "selectDeviceType" : "4";

    return (
        <APIContext.Provider value={{ goToPrevPage, currentPage, navigateToPage, isFinalConfirmationPage, postPersonaLandingPage }}>
            {children}
        </APIContext.Provider>
    );
};
